// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumbs_breadcrumb__dfwdY"};